import React, { Component, ErrorInfo, ReactNode } from 'react';
import Button from 'components/atoms/Button';
import { colorConstants } from 'config/colorConstants';
import { CrashScreenIcon } from 'assets/svg';
import { trackEventMixpanel } from 'utils/mixpanel';
import { ERROR_EVENTS } from 'utils/mixpanelEventNames';

interface ErrorBoundaryProps {
    children: ReactNode; // This defines that children can be any valid ReactNode
}

interface ErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        // Log the error to mixpanel
        trackEventMixpanel(ERROR_EVENTS, {
            errorMessage: error.stack,
            errorInfo: errorInfo.componentStack,
        });
    }

    render(): ReactNode {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div className={`fixed p-4 h-full w-full bg-greyBackgroundAlt `}>
                    <div
                        className={`bg-white flex flex-col justify-center items-center rounded-lg border border-borderLine relative h-full`}
                    >
                        <CrashScreenIcon />
                        <div className="text-center mb-4 !text-fontGray font-medium">
                            <span style={{ fontSize: '34px' }}>Something went wrong.</span>
                        </div>
                        <div className="mb-4">
                            <Button
                                title={'Reload Page'}
                                style={{
                                    color: colorConstants.white,
                                    backgroundColor: colorConstants.violet,
                                    borderRadius: '4px',
                                    padding: '12px 24px',
                                    width: '240px',
                                    height: '40px',
                                }}
                                onClick={() => {
                                    window.location.reload();
                                }}
                            />
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
